import {Group} from "@/types/Groups";
export interface MediaListResponse {
	mediaData: Media[];
	totalCount: number;
}
export interface Media {
	id: number;
	title: string;
	uid: number;
	vhost: number;
	parentid: number;
	status: number;
	moderationStatus?: number;
	filetype: number;
	channel: number;
	thumbUrl: string;
	publicUrl: string;
	injector?: string;
	extension: string;
	contenttype: string;
	metadata: any;
	groups?: Group[] | null;
	metadataArray: any;
	tags?: string;
	message: string;
	upload: string;
	parent_info?: any;
	user_firstname?: string;
	user_lastname?: string;
	user_email?: string;
	user_city?: string;
	user_name?: string;
	externalids?: (ExternalId | ExternalIdProviders)[] | undefined;
	statusInfo?: { conversion_percentage: number };
	geo_latitude?: string;
	geo_longitude?: string;
	hits?: number;
}         
export interface MediaOptions {
	includeCollectionDetails?:boolean;
	includeChildMedia?:boolean;
	voter_uid?:number;
	want_status?:number;
	childFilters?:any;
	childFields?:any;
	childSort?:string;
	parentFields?:any;
}
export interface MediaFilters {
	filetype?: number[];
	status?: number[];
	channel?: number | string;
	uid?: number;
	groupid?: number | number[];
	moderationStatus?: string;
	query?: string;
	extension?: string;
	contenttype?: string;
	startTime?: string;
	endTime?: string;
	parentid?: number;
	context?: string;
	title?: string;
	collection?: number;
	favoriteuid?: number;
	eventid?: number;
	includeChildren?: number;
	includeChildGroups?: number;
	exclude_children?: string;
	hidden?: string;
	geoBoundaries?: number[];
	geoCenter?: number[];
	geoDistance?: number;
}    


export interface MediaUpload {
	title: string;
	uid: number;
	parentid: number;
	status: number;
	moderationStatus?: number;
	filetype: number;
	channel: number;
	thumbUrl: string;
	publicUrl: string;
	injector?: string;
	extension: string;
	contenttype: string;
	metadata: any;
        metadataArray: unknown[];
        groupid: number[] | string[];
	tags?: string;
	message: string;
	upload: string;
	user_firstname?: string;
	user_lastname?: string;
	user_email?: string;
	user_city?: string;
	user_name?: string;
	externalids?: (ExternalId | ExternalIdProviders)[] | undefined;
}

export interface FileMeta {
	id?: number;
	provider?: string;
	key: string;
	grouping?: string;
	label?: string;
	prefill?: string;
	options?: string[] | string;
	type: 'textfield' | 'textarea' | 'dropdown' | 'checkbox' | 'date' | 'datefield' | 'multiselect' | 'api' | 'freeform' | 'numeric';
	source?: 'manual' | 'api' | 'derived';
	maxsize?: number;
	required?: boolean;
	defaultValue?: string;
	sort?: number;
	settings?: {
		defaultValue?: string;
		delim?: string;
		calculatedField?: number;
		defaultCategories?: any;
		options?: string[];
		[key: string]: any;
	};
}
export interface MetaGroup {
	provider: string;
	groupName?: string;
	items: FileMeta[];
}

export interface ExternalId {
  external_id: string;
  external_id_provider: string;
  created: string;
  vhost: string;
  primary_external_id: string;
}
export interface ExternalIdProviders {
	youtube?: Record<string, any>; // Replace `any` with specific types if available
	brightcove?: Record<string, any>;
	widen?: Record<string, any>;
	[key: string]: any; // To allow additional unknown providers
}

export const defaultMedia: Media = {
	id: 0,
	uid: 0,
	parentid: 0,
	vhost: 0,
	status:9 ,
	channel:9 ,
	tags:'' ,
	moderationStatus:9 ,
	filetype: 0,
	thumbUrl: '',
	publicUrl: '',
	extension: '',
	contenttype: '',
	metadata: null,
	groups: null,
	metadataArray: null,
	title: '',
	message: '',
	upload: ''
}

